import { useCallback, useEffect } from 'react';

/**
 * Custom hook for handling carousel selection and scroll state updates.
 */
function useCarouselSelection(emblaApi, setSelectedIndex, setCanScrollPrev, setCanScrollNext) {
    // Callback for updating carousel state
    const onSelect = useCallback(() => {
        if (!emblaApi)
            return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setCanScrollPrev(emblaApi.canScrollPrev());
        setCanScrollNext(emblaApi.canScrollNext());
    }, [emblaApi, setSelectedIndex, setCanScrollPrev, setCanScrollNext]);
    // Effect for setting up Embla event listeners
    useEffect(() => {
        if (!emblaApi)
            return;
        onSelect(); // Initial state update
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        return () => {
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [emblaApi, onSelect]);
}

export { useCarouselSelection };
